import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ItemOnlineReportContent from './ItemOnlineReportContent';
import { setFromDate, setToDate, setSelectedBranch, fetchItemOnlineFullReport } from './itemOnlineReportSlice';

const ItemOnlineReportManager = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';
    const storedBranchName = localStorage.getItem('branchname') || 'Current Branch';

    useEffect(() => {
        const today = new Date();
        dispatch(setFromDate(today));
        dispatch(setToDate(today));
        dispatch(setSelectedBranch({ branch_id: storedBranchId, branch_name: storedBranchName }));
        dispatch(
            fetchItemOnlineFullReport({
                fromDate: today,
                toDate: today,
                branchId: storedBranchId
            })
        );
    }, [dispatch, storedBranchId, storedBranchName]);

    return <ItemOnlineReportContent isManagerView />;
};

export default ItemOnlineReportManager;
